import AccountAccordion from "@components/Accordion/AccountAccordion";
import HeaderGroup from "@components/Account/Layout/Header/HeaderGroup";
import { PROFILE_ROUTES } from "@components/Account/Layout/utils";
import BottomBarPadding from "@components/BottomBarPadding";
import LBox from "@components/LBox";
import LScreen from "@components/LScreen";
import Stats from "@components/Stats";
import Community from "@components/Collection/artist/Community";
import { useManagedArtistIds } from "@hooks/trpc/useManagedArtists";
import { theme } from "@theme";
import { ScrollView } from "react-native";

const Dashboard = () => {
  const managedArtistIds = useManagedArtistIds();
  const artistId = managedArtistIds?.[0];

  return (
    <LScreen enableAutomaticTopPadding={true}>
      <LBox pb="s4">
        <HeaderGroup routes={PROFILE_ROUTES} />
      </LBox>
      <LBox flex={1}>
        <ScrollView
          showsVerticalScrollIndicator={false}
          showsHorizontalScrollIndicator={false}
          style={{ marginBottom: theme.spacing.l1 }}
          contentContainerStyle={{ gap: 20 }}
        >
          <AccountAccordion
            iconColor="#E8835B"
            iconName="revenue"
            title="Revenue"
          >
            <Stats />
          </AccountAccordion>
          <AccountAccordion
            iconColor="#E8835B"
            iconName="leaderboard"
            title="Community"
          >
            <Community artistId={artistId} />
          </AccountAccordion>
          <BottomBarPadding />
        </ScrollView>
      </LBox>
    </LScreen>
  );
};

export default Dashboard;
